import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { CustomPromsLegend } from "../CustomPromsLegend/CustomPromsLegend";
import {
  ChartLegendContainer,
  Container,
  DateLabel,
  Divider,
  MainValueContainer,
  MainValueContainerFirst,
  MainValuesContainer,
  NumberLabel,
  TextLabel,
} from "./CustomPromsGraphLegend.style";

type CustomPromsGraphLegendProps = {
  mainValues: any;
  empty: boolean;
  showValues: boolean;
  ranges: any;
};

export function CustomPromsGraphLegend({
  mainValues,
  empty,
  showValues,
  ranges,
}: CustomPromsGraphLegendProps) {
  const { t } = useTranslation();

  const { min, max, average, minValueDate, maxValueDate, minDate, maxDate } =
    mainValues;

  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    setDisabled(!min && !max && !average);
  }, [mainValues]);

  const chartLegendContainer = (
    <ChartLegendContainer paddingLeft={!showValues}>
      <CustomPromsLegend ranges={ranges} />
    </ChartLegendContainer>
  );

  const mainValuesContainer = (
    <MainValuesContainer>
      <MainValueContainerFirst>
        <NumberLabel disabled={disabled}>{average ?? "-"}</NumberLabel>
        <TextLabel disabled={disabled}>
          {t("patientPage_proms_legend_average")}
        </TextLabel>
        <DateLabel disabled={disabled}>
          {minDate || maxDate
            ? `${minDate ? dayjs(minDate).format("MMM D, YYYY") : "-"} - ${
                maxDate ? dayjs(maxDate).format("MMM D, YYYY") : "-"
              }`
            : "-"}
        </DateLabel>
      </MainValueContainerFirst>
      <MainValueContainerFirst>
        <NumberLabel disabled={disabled}>{max ?? "-"}</NumberLabel>
        <TextLabel disabled={disabled}>
          {t("patientPage_proms_legend_highest")}
        </TextLabel>
        <DateLabel disabled={disabled}>
          {dayjs(maxValueDate).format("MMM DD, YYYY") || "-"}
        </DateLabel>
      </MainValueContainerFirst>
      <MainValueContainer>
        <NumberLabel disabled={disabled}>{min ?? "-"}</NumberLabel>
        <TextLabel disabled={disabled}>
          {t("patientPage_proms_legend_lowest")}
        </TextLabel>
        <DateLabel disabled={disabled}>
          {dayjs(minValueDate).format("MMM DD, YYYY") || "-"}
        </DateLabel>
      </MainValueContainer>
    </MainValuesContainer>
  );

  return (
    <div style={{ position: "relative" }}>
      <Container>
        {showValues && mainValuesContainer}
        {!empty && <Divider />}
        {chartLegendContainer}
      </Container>
    </div>
  );
}
